export default "__VITE_ASSET__b7c94e26__"